import { Prestacion } from "../domain/entities/prestacion";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetPrestaciones {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(token: string): Promise<Prestacion[]> {
    const colPrestaciones: Prestacion[] =
      await this.protocoloService.getPrestaciones(token);
    return colPrestaciones;
  }
}
